// ============================================================================
// CASE ACCOUNT ENDPOINTS — Phase 9b-2
// ============================================================================
// BASE_PATH must match backend CaseAccountController route token.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_ACCOUNT_BASE_PATH = '/CaseAccount';

export const caseAccountEndpoints = {
  byCase: (caseId: ID) =>
    buildEndpointWithParams(`${CASE_ACCOUNT_BASE_PATH}/by-case/:caseId`, { caseId }),
  getById: (id: ID) =>
    buildEndpointWithParams(`${CASE_ACCOUNT_BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(CASE_ACCOUNT_BASE_PATH),
  update: (id: ID) =>
    buildEndpointWithParams(`${CASE_ACCOUNT_BASE_PATH}/:id`, { id }),
  delete: (id: ID) =>
    buildEndpointWithParams(`${CASE_ACCOUNT_BASE_PATH}/:id`, { id }),
  markPrimary: (id: ID) =>
    buildEndpointWithParams(`${CASE_ACCOUNT_BASE_PATH}/:id/mark-primary`, { id }),
} as const;

export default caseAccountEndpoints;
